import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import axios from 'axios';
const defaults = {
    title: "Confirmar",
    text: "",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#ed5565",
    confirmButtonText: "Eliminar",
    cancelButtonText: "Cancelar",
    reverseButtons: true,
};
export default{
    methods:{
        isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
        },
        file_get_contents(filename){
            fetch(filename).then((resp) => resp.text()).then(function(data) {
                return data;
            });
        },
        forEach(collection, callback, scope){
            if (Object.prototype.toString.call(collection) === '[object Object]') {
                for (var prop in collection) {
                    if (Object.prototype.hasOwnProperty.call(collection, prop)) {
                        callback.call(scope, collection[prop], prop, collection);
                    }
                }
            } else {
                for (var i = 0, len = collection.length; i < len; i++) {
                    callback.call(scope, collection[i], i, collection);
                }
            }
        },
        isNumber(e) {
            let key = e.keyCode || e.which;
            let keyString = String.fromCharCode(key).toLowerCase();
            let letters = "0123456789";
            let specials = [8, 9, 37, 39, 46, 44];
            let keySpecial = false;
            for (let i in specials) {
                if (key == specials[i]) {
                    keySpecial = true;
                    break;
                }
            }
            if (letters.indexOf(keyString) == -1 && !keySpecial) {
                e.preventDefault();
                return false;
            }
        },
        isLetter(e) {
            let key = e.keyCode || e.which;
            let keyString = String.fromCharCode(key).toLowerCase();
            let letters = "ABCDEFGHIJKLMÑNOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyz";
            let specials = [32];
            let keySpecial = false;
            for (let i in specials) {
                if (key == specials[i]) {
                    keySpecial = true;
                    break;
                }
            }
            if (letters.indexOf(keyString) == -1 && !keySpecial) {
                e.preventDefault();
                return false;
            }
        },
        isEmpty(value){
            if(value==undefined || value==null || value==''){
                return true;
            }
            if (this.isObject(value)) {
                return !Object.keys(value).length
            }
            return false;
        },
        isObject(o) {
            return o instanceof Object && o.constructor === Object;
        },
        confirm(options, callback, force){
            if (force == undefined)
                force = false;
           
            const settings = $.extend({}, defaults, options);
            Swal.fire(settings).then((result) => {
                if (force) {
                    callback(result);
                    return;
                }
                if (result.value) {
                    callback();
                }
            })
        },
        alert(options, callback){
            if(typeof options.icon == "undefined")
                options.icon = "info";
            options.showCancelButton=false;   
            options.confirmButtonText='Aceptar';
            options.confirmButtonColor='#3085d6';
            const settings = $.extend({}, defaults, options);
            if(this.isFunction(callback)){
                Swal.fire(settings).then((result) => {
                    callback(true);
                })
                return;
            }
            Swal.fire(settings);
        },
        alertSuccess(message,callback){
            this.alert({icon:'success',title:'Mensaje',text:message},callback);
        },
        alertWarning(message,callback){
            this.alert({icon:'warning',title:'Advertencia',text:message},callback);
        },
        alertError(message,callback){
            this.alert({icon:'error',title:'Error',text:message},callback);
        },
        alertInfo(message,callback){
            this.alert({icon:'info',title:'Info',text:message},callback);
        },
        extractDate(value, type){
            let arr=[];
            if(value){
                arr = value.split("-");
                if(!type){
                    return value;
                }else if(type=='d'){
                    return arr[2];
                }else if(type=='m'){
                    return arr[1];
                }else if(type=='y'){
                    return arr[0];
                }
            }
        },
        getNameMountShort(value){
            if(value=='01'){
                return "Ene";
            }else if(value=='02'){
                return "Feb";
            }else if(value=='03'){
                return "Mar";
            }else if(value=='04'){
                return "Abr";
            }else if(value=='05'){
                return "May";
            }else if(value=='06'){
                return "Jun";
            }else if(value=='07'){
                return "Jul";
            }else if(value=='08'){
                return "Ago";
            }else if(value=='09'){
                return "Set";
            }else if(value=='10'){
                return "Oct";
            }else if(value=='11'){
                return "Nov";
            }else if(value=='12'){
                return "Dic";
            }
        },
        getNameMountLarge(value){
            if(value=='01'){
                return "Enero";
            }else if(value=='02'){
                return "Febrero";
            }else if(value=='03'){
                return "Marzo";
            }else if(value=='04'){
                return "Abril";
            }else if(value=='05'){
                return "Mayo";
            }else if(value=='06'){
                return "Junio";
            }else if(value=='07'){
                return "Julio";
            }else if(value=='08'){
                return "Agosto";
            }else if(value=='09'){
                return "Setiembre";
            }else if(value=='10'){
                return "Octubre";
            }else if(value=='11'){
                return "Noviembre";
            }else if(value=='12'){
                return "Diciembre";
            }
        },
        restarHoras(data2, data1){
            console.log(data1);
            console.log(data2);
            if(!data1)
                data1 = new Date();
            else
                data1 = new Date(data1);
            
            if(!data2)
                data2 = new Date();
            else
                data2 = new Date(data2);
            
            var resultado = ((data2-data1)/1000);
            return resultado;
        },
        diasSemana(){
            return [
                'domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'
            ];
        },
        meses(){
            return [
                {"id":"01", "descripcion":"enero"}
                , {"id":"02", "descripcion":"febrero"}
                , {"id":"03", "descripcion":"marzo"}
                , {"id":"04", "descripcion":"abril"}
                , {"id":"05", "descripcion":"mayo"}
                , {"id":"06", "descripcion":"junio"}
                , {"id":"07", "descripcion":"julio"}
                , {"id":"08", "descripcion":"agosto"}
                , {"id":"09", "descripcion":"setiembre"}
                , {"id":"10", "descripcion":"octubre"}
                , {"id":"11", "descripcion":"noviembre"}
                , {"id":"12", "descripcion":"diciembre"}
            ];
        },
        obtenerNombreMes(numero){
            let miFecha = new Date();
            if (0 < numero && numero <= 12) {
                miFecha.setMonth(numero - 1);
                return new Intl.DateTimeFormat('es-ES', { month: 'long'}).format(miFecha);
            } else {
                return null;
            }
        },
        in_array(_string, _array) {
            return (_array.indexOf(_string) != -1);
        },
        str_pad (input, padLength, padString, padType) {
            let half = ''
            let padToGo
            const _strPadRepeater = function (s, len) {
              let collect = ''
              while (collect.length < len) {
                collect += s
              }
              collect = collect.substr(0, len)
              return collect
            }
            input += ''
            padString = padString !== undefined ? padString : ' '
            if (padType !== 'STR_PAD_LEFT' && padType !== 'STR_PAD_RIGHT' && padType !== 'STR_PAD_BOTH') {
              padType = 'STR_PAD_RIGHT'
            }
            if ((padToGo = padLength - input.length) > 0) {
              if (padType === 'STR_PAD_LEFT') {
                input = _strPadRepeater(padString, padToGo) + input
              } else if (padType === 'STR_PAD_RIGHT') {
                input = input + _strPadRepeater(padString, padToGo)
              } else if (padType === 'STR_PAD_BOTH') {
                half = _strPadRepeater(padString, Math.ceil(padToGo / 2))
                input = half + input + half
                input = input.substr(0, padLength)
              }
            }
            return input
        },
        capitalizarPrimeraLetra(cadena) {
            console.log(cadena);
            const primerCaracter = cadena.charAt(0).toUpperCase();
            const restoDeLaCadena = cadena.substring(1, cadena.length);
            return primerCaracter.concat(restoDeLaCadena);
        },
        fecha_actual(){
            var f = new Date();
            return this.str_pad(f.getDate(), 2, '0', 'STR_PAD_LEFT') + "-"+ this.str_pad(f.getMonth(), 2,'0', 'STR_PAD_LEFT')+ "-" +f.getFullYear();
        },
        fecha_actual_es(){
            var f = new Date();
            return f.getFullYear() + "-"+ this.str_pad(f.getMonth(), 2,'0', 'STR_PAD_LEFT')+ "-"+this.str_pad(f.getDate(), 2, '0', 'STR_PAD_LEFT');
        },
        mes_actual(){
            var f = new Date();
            return this.str_pad(f.getMonth(), 2,'0', 'STR_PAD_LEFT');
        },
        dia_actual(){
            var f = new Date();
            return this.str_pad(f.getDate(), 2, '0', 'STR_PAD_LEFT');
        },
        validEmail (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        downloadItem(file, label){
            console.log(file);
            console.log(label);
            axios({
                url: file,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                console.log(url);
                const link = document.createElement('a');
                console.log(link);
                link.href = url;
                link.setAttribute('download', label);
                document.body.appendChild(link);
                link.click();
            });
        },
        dateFormat(value,format){
            if(format==undefined){
                format='DD/MM/YYYY';
            }
            return dayjs(value).format(format)
        },
    }
}